// 默认用户头像
export const defaultUserAvatar: string = require('@/common/basis/assets/default_head_photo.png');
